export default __webpack_public_path__ + "static/media/img_papaground11.2561ff15.jpg";